<script>
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import { setAuth } from "../stores/helpers";
    let phoneNumber;
    let code;

    function loginConfirm() {
      fetch(`/api/v1/login-confirm`, {
          body: JSON.stringify({
              phoneNumber,
              code,
          }),
          method: 'POST',
          'content-type': 'application/json',
      })
      .then(res => {
          setAuth({
            isAuthenticated: true
          })

          navigate("/");
      })
    }

    onMount(() => {
      const urlParams = new URLSearchParams(window.location.search);
      phoneNumber = urlParams.get('phoneNumber');
      if (!phoneNumber) navigate('/login');
    });
</script>
<main>
    <h3 class="center">Enter the code sent to your mobile</h3>
    <div class="center">
        <form id="login-confirm-code-form">
            <input bind:value={code} class="input" type="text" name="CODE" autocomplete="off" placeholder="Enter Code" data-required="true" required />
            <button on:click|preventDefault={loginConfirm} type="submit" form="login-confirm-code-form" class="primary">
                Go    
            </button>
        </form>
    </div>
</main>

<style>
  .center {
    text-align: center;
  }
</style>